<template>
  <div style="min-height: 100px" v-loading="loading">
    <div v-if="replenishInfo">
      <el-card shadow="hover">
        <div style="padding: 10px">
          <warehouse-replenish-info :replenishInfo="replenishInfo" :showCost="true" />
          <div style="margin-top: 10px" v-if="replenishInfo.optCancel == 0">
            <el-button
              v-if="
                replenishInfo.optStatus == 0 ||
                replenishInfo.optStatus == 1 ||
                replenishInfo.optStatus == 2
              "
              :size="$xUISize"
              @click="editClick"
              type="default"
            >
              编辑
            </el-button>
            <el-button
              v-if="replenishInfo.optWaitPurchase"
              :size="$xUISize"
              @click="purchaseClick"
              type="primary"
            >
              标记已采购
            </el-button>
            <el-button
              v-if="
                (replenishInfo.optStatus == 0 ||
                  replenishInfo.optStatus == 1 ||
                  replenishInfo.optStatus == 2) &&
                replenishInfo.inboundGoodsCount <= 0
              "
              :size="$xUISize"
              @click="cancelClick"
              type="danger"
            >
              取消
            </el-button>
          </div>
        </div>
      </el-card>
      <div>
        <x-tab v-model="tabName" :tabs="tabs" :query="tabParams" :params="tabParams" />
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.replenish-detail {
  margin-top: 20px;
}
</style>

<script>
import replenishFromPage from "./__replenish_form.vue";
import detailItemList from "./__detail_item_list_storehouse.vue";
import warehouseReplenishInfo from "../../../../components/business/warehouseReplenishInfo.vue";

export default {
  components: {
    warehouseReplenishInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    tabParams() {
      if (!this.replenishInfo) {
        return {};
      }
      return {
        guid: this.replenishInfo.guid,
        replenishGuid: this.replenishInfo.guid,
        storeGuid: this.replenishInfo.storeGuid,
      };
    },
    tabs() {
      if (!this.replenishInfo) {
        return [];
      }
      let tabList = [
        {
          name: "replenish-item-list",
          label: "供货清单",
          component: detailItemList,
          interval: true,
        },
      ];
      return tabList;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      replenishInfo: null,
      printLoading: false,
      cancelLoading: false,
      tabName: "",
    };
  },
  methods: {
    editClick() {
      if (!this.replenishInfo) {
        return;
      }
      this.$drawer.openDrawer({
        title: "编辑供货单信息",
        refresh: () => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        },
        component: replenishFromPage,
        params: {
          guid: this.replenishInfo.guid,
          storeGuid: this.replenishInfo.storehouseGuid,
        },
      });
    },
    purchaseClick() {
      if (!this.replenishInfo) {
        return;
      }
      this.$confirm("确认标记为已采购？", "确认", {
        type: "info",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.replenish.info.purchase",
          {
            guid: this.replenishInfo.guid,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    cancelClick() {
      if (!this.replenishInfo) {
        return;
      }
      this.$confirm("确认取消当前供货单？", "确认", {
        type: "error",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.replenish.info.cancel",
          {
            guid: this.replenishInfo.guid,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.replenishInfo = null;
      return this.requestApi("biz.warehouse.replenish.info.detail", {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid,
      })
        .then((resp) => {
          this.replenishInfo = resp.data;
        })
        .catch((err) => {
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.tabName = this.pageParams.tabName;
    this.getDetail();
  },
};
</script>
